import { cx, useTranslations } from "@jugl-web/utils";
import { useInvoicesSettingsPageContext } from "@web-src/modules/invoices/pages/InvoicesSettingsPage/context/useInvoicesSettingsPageContext";
import { useDueInOptions } from "@web-src/modules/invoices/hooks/useDueInOptions";
import { useRef } from "react";
import { ListBox, Popover } from "@jugl-web/ui-components";
import { Controller } from "react-hook-form";
import { ReactComponent as ChevronDownIcon } from "./assets/chevron-down.svg";

export const DueInField = () => {
  const { t } = useTranslations();
  const { control, formValues } = useInvoicesSettingsPageContext();
  const { options } = useDueInOptions(false);
  const selectedOption = options.find(
    (option) => option.id === formValues.dueIn.toString()
  );
  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <div className="max-w-sm">
      <h2 className="font-secondary my-0 text-base font-medium">
        {t({
          id: "invoices.settings.businessInformation.dueInSettings.title",
          defaultMessage: "Due in",
        })}
      </h2>

      <div className="mt-8">
        <div className="w-full" ref={wrapperRef}>
          <Controller
            name="dueIn"
            control={control}
            render={({ field: { onChange } }) => (
              <Popover
                placement="bottom-start"
                className="px-3 py-2"
                renderTrigger={({ Trigger, triggerRef, isOpen }) => (
                  <Trigger
                    ref={triggerRef}
                    className="border-grey-400 text-dark flex h-14 w-full cursor-pointer items-center justify-between rounded-xl border border-solid bg-transparent px-5 text-base font-normal outline-none"
                  >
                    <span>{selectedOption?.value}</span>
                    <ChevronDownIcon
                      className={cx(
                        "shrink-0 transition-transform",
                        isOpen && "rotate-180"
                      )}
                    />
                  </Trigger>
                )}
              >
                {({ onClose }) => (
                  <div
                    className="relative"
                    style={{
                      width: (wrapperRef.current?.offsetWidth || 0) - 24,
                    }}
                  >
                    <ListBox
                      items={options}
                      selectionBehavior={{ mode: "single", canToggle: true }}
                      onSelect={(item) => {
                        onChange(item.id.toString(), { shouldValidate: true });
                        onClose();
                      }}
                      defaultSelectedIds={[formValues.dueIn.toString()]}
                      renderLabel={(item) => item.value}
                      itemSize="sm"
                      spaceBetweenItems="compact"
                    />
                  </div>
                )}
              </Popover>
            )}
          />
        </div>
      </div>
    </div>
  );
};
